/* 7MotorParts theme script — no dependencies. */
(function () {
  'use strict';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = window.moneyFormat || '£{{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, whole.replace(/,/g, '.') + ',' + parts[1])
      .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
  }

  /* ---------- Protected email links (see snippets/email-guard.liquid) ---------- */
  // The address is stored reversed and split so harvesters never see it in the HTML.
  document.querySelectorAll('a.eml[data-u][data-d]').forEach(function (a) {
    var rev = function (s) { return s.split('').reverse().join(''); };
    var address = rev(a.dataset.u) + '@' + rev(a.dataset.d);
    a.href = 'mai' + 'lto:' + address;
    a.textContent = address;
    a.removeAttribute('data-u');
    a.removeAttribute('data-d');
  });

  /* ---------- Header: search + mobile drawer ---------- */
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = document.getElementById('header-search');
      if (!panel) return;
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      if (open) panel.querySelector('input').focus();
    });
  });

  var drawer = document.getElementById('menu-drawer');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    if (open) { var f = drawer.querySelector('a, button'); if (f) f.focus(); }
  }
  document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  /* ---------- Mega menu: hover-intent on categories, click/keyboard to open ---------- */
  document.querySelectorAll('[data-mega]').forEach(function (mega) {
    var item = mega.closest('.nav__item');
    var trigger = item.querySelector('.nav__link');
    var cats = mega.querySelectorAll('[data-mega-cat]');
    var intent;
    function activate(cat) {
      cats.forEach(function (c) { c.classList.toggle('is-active', c === cat); });
    }
    function setOpen(open) {
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open);
    }
    cats.forEach(function (cat) {
      cat.addEventListener('mouseenter', function () {
        clearTimeout(intent);
        intent = setTimeout(function () { activate(cat); }, 90);
      });
      cat.addEventListener('mouseleave', function () { clearTimeout(intent); });
      cat.querySelector('.mega__cat-link').addEventListener('focus', function () { activate(cat); });
    });
    item.addEventListener('mouseenter', function () { setOpen(true); });
    item.addEventListener('mouseleave', function () { setOpen(false); });
    // Touch screens without hover: first tap opens the panel, second tap follows the link.
    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
        e.preventDefault(); setOpen(true);
      }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { setOpen(false); trigger.focus(); trigger.blur(); }
    });
    document.addEventListener('click', function (e) { if (!item.contains(e.target)) setOpen(false); });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + (btn.dataset.qty === 'plus' ? 1 : -1);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart count + toast ---------- */
  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById('cart-toast');
    if (!t) return;
    t.querySelector('.toast__msg').textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 4500);
  }
  function refreshCount() {
    return fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.dataset.count = cart.item_count;
        });
      });
  }

  /* ---------- Product form ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var root = form.closest('[data-product]');
    var dataEl = root && root.querySelector('[data-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = form.querySelector('input[name="id"]');
    var submit = form.querySelector('[type="submit"]');

    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option]'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function updateAvailability(opts) {
      // grey out values that have no available variant in combination with the other picks
      root.querySelectorAll('[data-option]').forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return i === idx || o === test[i]; }) && v.options[idx] === input.value;
          });
          input.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
        var label = fs.querySelector('[data-option-value]');
        if (label) label.textContent = opts[idx] || '';
      });
    }

    function onChange(e) {
      var opts = selectedOptions();
      var variant = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      // The picked combination doesn't exist: keep the value just chosen and
      // move the other options to the closest combination that does.
      if (!variant && e && e.target) {
        var sets = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
        var idx = sets.indexOf(e.target.closest('[data-option]'));
        var cands = product.variants.filter(function (v) { return v.options[idx] === opts[idx]; });
        variant = cands.find(function (v) { return v.available; }) || cands[0];
        if (variant) {
          variant.options.forEach(function (val, i) {
            var input = Array.prototype.find.call(sets[i].querySelectorAll('input'), function (x) { return x.value === val; });
            if (input) input.checked = true;
          });
          opts = selectedOptions();
        }
      }
      updateAvailability(opts);
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var skuEl = root.querySelector('[data-sku]');
      var stockEl = root.querySelector('[data-stock]');
      if (!variant) {
        submit.disabled = true;
        submit.querySelector('span').textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.toggle('price--sale', variant.compare_at_price > variant.price);
      }
      if (compareEl) {
        compareEl.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price) : '';
      }
      if (skuEl) {
        skuEl.textContent = variant.sku || '—';
      }
      if (stockEl) {
        stockEl.classList.toggle('is-out', !variant.available);
        stockEl.textContent = variant.available ? 'In stock — ready to dispatch' : 'Out of stock';
      }
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? 'Add to basket' : 'Sold out';
      if (variant.featured_media) {
        var thumb = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    // Shopify keeps option values in first-variant order, so "50 pcs" can land after
    // "200 pcs". Sort a group numerically when every value starts with a number.
    (root ? root.querySelectorAll('.opt__values') : []).forEach(function (group) {
      var pairs = Array.prototype.map.call(group.querySelectorAll('input'), function (input) {
        return { input: input, label: input.nextElementSibling, n: parseFloat(input.value) };
      });
      if (pairs.length < 2 || pairs.some(function (p) { return isNaN(p.n); })) return;
      pairs.sort(function (a, b) { return a.n - b.n; }).forEach(function (p) {
        group.appendChild(p.input);
        group.appendChild(p.label);
      });
    });

    if (product && product.variants.length > 1) {
      root.querySelectorAll('[data-option] input').forEach(function (i) { i.addEventListener('change', onChange); });
      updateAvailability(selectedOptions());
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var label = submit.querySelector('span');
      var idle = label.textContent;
      submit.disabled = true;
      submit.classList.add('is-loading');
      submit.setAttribute('aria-busy', 'true');
      label.textContent = 'Adding…';
      fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to basket');
          showToast((res.body.product_title || 'Item') + ' added to your basket');
          return refreshCount();
        })
        .catch(function (err) { showToast(err.message); })
        .then(function () {
          submit.disabled = false;
          submit.classList.remove('is-loading');
          submit.removeAttribute('aria-busy');
          label.textContent = idle;
        });
    });

    // Mobile sticky buy bar: mirrors the main button and price, appears once the main button is off screen
    var bar = root && root.querySelector('[data-sticky-buy]');
    if (bar && 'IntersectionObserver' in window) {
      var barBtn = bar.querySelector('[data-sticky-submit]');
      var barPrice = bar.querySelector('[data-sticky-price]');
      var mainPrice = root.querySelector('[data-price]');
      var sync = function () {
        barBtn.disabled = submit.disabled;
        barBtn.classList.toggle('is-loading', submit.classList.contains('is-loading'));
        barBtn.querySelector('span').textContent = submit.querySelector('span').textContent;
        if (mainPrice) barPrice.textContent = mainPrice.textContent;
      };
      var mo = new MutationObserver(sync);
      mo.observe(submit, { attributes: true, childList: true, subtree: true, characterData: true });
      if (mainPrice) mo.observe(mainPrice, { childList: true, subtree: true, characterData: true });
      bar.hidden = false;
      new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', off);
        document.body.classList.toggle('has-sticky-buy', off);
      }).observe(submit);
      barBtn.addEventListener('click', function () { submit.click(); });
    }
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main] img');
    g.querySelectorAll('[data-media-id]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = thumb.dataset.alt || '';
        g.querySelectorAll('[data-media-id]').forEach(function (t) { t.setAttribute('aria-current', t === thumb); });
      });
    });
  });

  /* ---------- Collection filters & sort ---------- */
  document.querySelectorAll('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
  document.querySelectorAll('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  document.querySelectorAll('[data-filters-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.getElementById(b.getAttribute('aria-controls'));
      var open = f.classList.toggle('is-open');
      b.setAttribute('aria-expanded', open);
    });
  });

  /* ---------- Cart page: auto-update qty ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 450);
    });
  }

  /* ---------- My bike (garage) ---------- */
  // The rider's bike lives in localStorage only. Fitment text = product title + custom.fitment lines;
  // a line fits when it names the model (as a whole word), no other make, and a year range that includes the year.
  var Garage = (function () {
    var KEY = '7mp-bike', ONLY = '7mp-bike-only';
    var makes = (window.garageMakes || []).map(function (m) { return norm(m); }).filter(Boolean);

    function store(k, v) { try { if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
    function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function norm(s) {
      return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ').replace(/([a-z]) (?=\d)/g, '$1').trim();
    }
    function has(text, word) { return word && (' ' + text + ' ').indexOf(' ' + word + ' ') !== -1; }

    function get() { try { return JSON.parse(read(KEY)); } catch (e) { return null; } }
    function name(b) { return b ? [b.make, b.model, b.year].filter(Boolean).join(' ') : ''; }

    // 'fits' | 'no' | 'universal' (one-size parts) | 'generic' (no bike named, e.g. oil)
    function status(bike, text) {
      if (!bike || !text) return 'generic';
      if (/universal/i.test(text)) return 'universal';
      var lines = text.split(/\n/).map(function (l) { return l.trim(); }).filter(Boolean);
      var namesBike = lines.some(function (l) { var n = norm(l); return makes.some(function (m) { return has(n, m); }); });
      if (!namesBike) return 'generic';
      var make = norm(bike.make), model = norm(bike.model), year = parseInt(bike.year, 10);
      var fits = lines.some(function (line) {
        var n = norm(line);
        var models = model.split(' ');
        if (!models.every(function (w) { return has(n, w); })) return false;
        if (makes.some(function (m) { return m !== make && has(n, m); })) return false;
        if (!year) return true;
        var ranges = line.match(/(19|20)\d\d\s*[–—-]\s*(19|20)\d\d/g);
        if (ranges) return ranges.some(function (r) { var y = r.match(/\d{4}/g).map(Number); return year >= y[0] && year <= y[1]; });
        var single = line.match(/\b(19|20)\d\d\b/g);
        return !single || single.map(Number).indexOf(year) !== -1;
      });
      return fits ? 'fits' : 'no';
    }

    function searchUrl(b) {
      var url = new URL(window.routes.search_url || '/search', window.location.origin);
      url.searchParams.set('q', [b.make, b.model, b.year].filter(Boolean).join(' '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      return url.toString();
    }

    var pop = document.getElementById('garage-pop');
    var toggles = document.querySelectorAll('[data-garage-toggle]');
    function setPop(open) {
      if (!pop) return;
      pop.hidden = !open;
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open); });
      if (open) { var f = pop.querySelector(get() ? '[data-garage-shop]' : 'select'); if (f) f.focus(); }
    }

    function render() {
      var bike = get();
      document.querySelectorAll('[data-garage-label]').forEach(function (el) { el.textContent = bike ? bike.model : 'My bike'; });
      toggles.forEach(function (t) { t.classList.toggle('is-set', !!bike); });
      if (pop) {
        pop.querySelector('[data-garage-saved]').hidden = !bike;
        pop.querySelector('[data-garage-form-title]').textContent = bike ? 'Change bike' : 'Add your bike';
        if (bike) {
          pop.querySelector('[data-garage-name]').textContent = name(bike);
          pop.querySelector('[data-garage-shop]').href = searchUrl(bike);
          var form = pop.querySelector('[data-garage-form]');
          form.make.value = bike.make; form.model.value = bike.model; form.year.value = bike.year || '';
        }
      }
      markCards(bike);
      markProduct(bike);
      renderBar(bike);
    }

    function markCards(bike) {
      document.querySelectorAll('.card[data-fit]').forEach(function (card) {
        var badges = card.querySelector('.card__badges');
        var old = card.querySelector('.badge--fit');
        if (old) old.remove();
        var s = status(bike, card.getAttribute('data-fit'));
        card.dataset.fitStatus = bike ? s : '';
        if (bike && s === 'fits' && badges) {
          var b = document.createElement('span');
          b.className = 'badge badge--fit';
          b.textContent = 'Fits your ' + bike.model;
          badges.prepend(b);
        }
      });
      applyOnly(bike);
    }

    function applyOnly(bike) {
      var only = !!bike && read(ONLY) === '1';
      var shown = 0, total = 0;
      document.querySelectorAll('.card[data-fit]').forEach(function (card) {
        var item = card.closest('.grid > *') || card;
        if (item.dataset.yearHidden) return;
        total++;
        var hide = only && card.dataset.fitStatus === 'no';
        item.classList.toggle('is-garage-hidden', hide);
        if (!hide) shown++;
      });
      var note = document.querySelector('[data-garage-count]');
      if (note) note.textContent = only ? shown + ' of ' + total + ' on this page' : '';
    }

    function markProduct(bike) {
      var box = document.querySelector('[data-fit-check]');
      if (!box) return;
      var line = box.querySelector('.fitment__mine');
      if (!line) {
        line = document.createElement('div');
        line.className = 'fitment__mine';
        box.querySelector('.fitment__head').after(line);
      }
      var s = status(bike, box.getAttribute('data-fit-check'));
      line.className = 'fitment__mine fitment__mine--' + (bike ? s : 'none');
      line.textContent = '';
      var text = document.createElement('span');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('data-garage-toggle', '');
      btn.textContent = bike ? 'Change bike' : 'Add your bike';
      if (!bike) text.textContent = 'Add your bike and we\'ll check it fits.';
      else if (s === 'fits') text.textContent = '✓ Fits your ' + name(bike);
      else if (s === 'no') text.textContent = 'Not listed for your ' + name(bike) + ' – ask us before ordering.';
      else if (s === 'universal') text.textContent = 'Universal part – check the size for your ' + bike.model + '.';
      else text.textContent = 'Check the spec in your ' + bike.model + ' owner\'s manual.';
      line.append(text, btn);
    }

    function renderBar(bike) {
      if (!/\btpl-(collection|search)\b/.test(document.body.className)) return;
      var grid = document.querySelector('main .grid');
      if (!grid) return;
      var bar = document.querySelector('[data-garage-bar]');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'garage-bar';
        bar.setAttribute('data-garage-bar', '');
        grid.before(bar);
      }
      bar.textContent = '';
      var label = document.createElement('span');
      label.className = 'garage-bar__bike';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'garage-bar__link';
      btn.setAttribute('data-garage-toggle', '');
      if (!bike) {
        label.textContent = 'See which parts fit your bike';
        btn.textContent = 'Add your bike';
        bar.append(label, btn);
        return;
      }
      label.textContent = 'Your bike: ' + name(bike);
      var only = document.createElement('label');
      only.className = 'garage-bar__only';
      only.innerHTML = '<input type="checkbox"> Only show parts that fit';
      var cb = only.querySelector('input');
      cb.checked = read(ONLY) === '1';
      cb.addEventListener('change', function () { store(ONLY, cb.checked ? '1' : null); applyOnly(get()); });
      var count = document.createElement('span');
      count.className = 'garage-bar__count mono muted';
      count.setAttribute('data-garage-count', '');
      btn.textContent = 'Change';
      bar.append(label, only, count, btn);
      applyOnly(bike);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-garage-toggle]')) { setPop(pop && pop.hidden); return; }
      if (e.target.closest('[data-garage-remove]')) { store(KEY, null); render(); return; }
      if (pop && !pop.hidden && !e.target.closest('#garage-pop')) setPop(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setPop(false); });
    var gform = pop && pop.querySelector('[data-garage-form]');
    if (gform) gform.addEventListener('submit', function (e) {
      e.preventDefault();
      save({ make: gform.make.value, model: gform.model.value, year: gform.year.value });
      setPop(false);
    });

    function save(b) {
      b = { make: (b.make || '').trim(), model: (b.model || '').trim(), year: (b.year || '').trim() };
      if (!b.make || !b.model) return;
      if (!/^(19|20)\d\d$/.test(b.year)) b.year = '';
      store(KEY, JSON.stringify(b));
      render();
    }

    render();
    return { get: get, save: save, refresh: function () { applyOnly(get()); } };
  })();

  /* ---------- Predictive search (part numbers, models, brands) ---------- */
  // "HF 204" and "hf-204" are retried as "HF204", since part numbers are stored without spaces.
  function joinPartNo(q) { return q.replace(/\b([a-z]{1,5})[\s-]+(\d)/gi, '$1$2'); }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function highlight(text, q) {
    var safe = escapeHtml(text);
    q.split(/\s+/).filter(function (w) { return w.length > 1; }).forEach(function (w) {
      safe = safe.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
    });
    return safe;
  }

  document.querySelectorAll('[data-predict-input]').forEach(function (input) {
    var box = document.getElementById(input.getAttribute('aria-controls'));
    if (!box) return;
    var timer, seq = 0, active = -1;
    var base = (window.routes.predictive_search_url || '/search/suggest') + '.json';

    function fetchResults(q) {
      var url = new URL(base, window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product,collection');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.sku,variants.title,vendor,tag');
      return fetch(url.toString(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) { var r = j.resources.results; return { products: r.products || [], collections: r.collections || [] }; });
    }

    function close() { box.hidden = true; active = -1; input.setAttribute('aria-expanded', 'false'); }

    function show(res, q) {
      var html = '';
      if (res.collections.length) {
        html += '<div class="predict__group">Categories</div>';
        res.collections.slice(0, 3).forEach(function (c) {
          html += '<a class="predict__item predict__item--coll" role="option" href="' + c.url + '">' + highlight(c.title, q) + '</a>';
        });
      }
      if (res.products.length) {
        html += '<div class="predict__group">Parts</div>';
        res.products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          var price = formatMoney(Math.round(parseFloat(p.price) * 100));
          html += '<a class="predict__item" role="option" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '<span class="predict__noimg"></span>') +
            '<span class="predict__text"><span class="predict__title">' + highlight(p.title, q) + '</span>' +
            '<span class="predict__meta">' + (p.vendor ? escapeHtml(p.vendor) + ' · ' : '') + price + (p.available ? '' : ' · Sold out') + '</span></span></a>';
        });
      }
      if (!html) {
        html = '<p class="predict__empty">No parts match “' + escapeHtml(q) + '”. Try the model or the part number without spaces.</p>';
      }
      var all = new URL(window.routes.search_url || '/search', window.location.origin);
      all.searchParams.set('q', joinPartNo(q)); all.searchParams.set('type', 'product');
      html += '<a class="predict__all" role="option" href="' + all.toString() + '">See all results for “' + escapeHtml(q) + '” →</a>';
      box.innerHTML = html;
      box.hidden = false;
      active = -1;
      input.setAttribute('aria-expanded', 'true');
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        var mine = ++seq;
        fetchResults(q).then(function (res) {
          var joined = joinPartNo(q);
          if (!res.products.length && joined !== q) return fetchResults(joined).then(function (r2) { return { res: r2, q: joined }; });
          return { res: res, q: q };
        }).then(function (out) { if (mine === seq) show(out.res, out.q); })
          .catch(function () { close(); });
      }, 180);
    });

    input.addEventListener('keydown', function (e) {
      var items = box.querySelectorAll('a');
      if (box.hidden || !items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
        items[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active > -1) {
        e.preventDefault();
        window.location.href = items[active].href;
      } else if (e.key === 'Escape') {
        close();
      }
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.predict-wrap')) close(); });
    // Submitting "HF 204" searches for "HF204"
    var form = input.form;
    if (form) form.addEventListener('submit', function () { input.value = joinPartNo(input.value.trim()); });
  });

  /* ---------- Quick add (cross-sell strip) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    btn.disabled = true;
    fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to basket');
        showToast((res.body.product_title || 'Item') + ' added to your basket');
        btn.textContent = 'Added';
        return refreshCount();
      })
      .catch(function (err) { showToast(err.message); btn.disabled = false; });
  });

  /* ---------- Basket: save the oil-change reminder choice straight away ---------- */
  document.querySelectorAll('[data-reminder]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var attrs = {}; attrs[cb.name.replace(/^attributes\[|\]$/g, '')] = cb.checked ? 'Yes' : 'No';
      fetch(window.routes.cart_url + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
    });
  });

  /* ---------- Fitment year check on search results ---------- */
  // Shopify search ignores the year, so hide products whose year ranges (e.g. "2017–2026") exclude it.
  (function () {
    var q = new URLSearchParams(window.location.search).get('q') || '';
    var m = q.match(/\b(19[5-9]\d|20\d\d)\b/);
    if (!m || !document.querySelector('[data-fit]')) return;
    var year = parseInt(m[1], 10), shown = 0, hidden = 0;
    document.querySelectorAll('[data-fit]').forEach(function (card) {
      var ranges = card.getAttribute('data-fit').match(/(19|20)\d\d\s*[–—-]\s*(19|20)\d\d/g);
      var item = card.closest('li, .grid > *') || card;
      var fits = !ranges || ranges.some(function (r) {
        var y = r.match(/\d{4}/g).map(Number);
        return year >= y[0] && year <= y[1];
      });
      if (fits) { shown++; } else { item.hidden = true; item.dataset.yearHidden = '1'; hidden++; }
    });
    Garage.refresh();
    var count = document.querySelector('[data-results-count]');
    if (count && hidden) {
      count.textContent = shown ? shown + (shown === 1 ? ' part fits ' : ' parts fit ') + year
        : 'Nothing listed for ' + year + ' yet – get in touch and we will check fitment for you.';
    }
  })();

  /* ---------- Fitment finder → search ---------- */
  document.querySelectorAll('[data-finder]').forEach(function (form) {
    var fields = form.querySelectorAll('[data-term]');
    var bike = Garage.get();
    if (bike && fields.length === 3 && !fields[1].value) {
      fields[0].value = bike.make; fields[1].value = bike.model; fields[2].value = bike.year || '';
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Remember the bike so cards across the shop can show "Fits your …"
      if (fields.length === 3) Garage.save({ make: fields[0].value, model: fields[1].value, year: fields[2].value });
      var terms = Array.prototype.map.call(form.querySelectorAll('[data-term]'), function (el) { return el.value.trim(); })
        .filter(Boolean);
      var url = new URL(form.action, window.location.origin);
      url.searchParams.set('q', terms.join(' '));
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      window.location.href = url.toString();
    });
  });
})();
